/**
 * Sport File Extensions
 *
 * Some sports use non-SVG team logo files.
 * This module provides a lookup for the correct file extension.
 */

/** Sports that use a non-default file extension for team logos */
export const SPORT_FILE_EXTENSIONS: Record<string, string> = {
  mlb: 'png',
  nba: 'png',
  // Basketball artwork is png, and the playable seed writes .png. Without this the default
  // 'svg' is synthesised by generateTeamLogoUrl / normalizeTeamLogoUrl and every WNBA logo
  // 404s — the seed and the URL builders disagreeing about the extension (DKPLAT-827).
  wnba: 'png',
  ncaamb: 'png',
  // NFL team logos are PNG. This also makes the low-res opt-in work
  // (DKPLAT-669): `teams-low/` holds PNGs only, so an SVG URL rewrote to a
  // `teams-low/{CODE}.svg` that does not exist.
  nfl: 'png',
};

/** Default file extension for team logos */
export const DEFAULT_FILE_EXTENSION = 'svg';

/**
 * Get the file extension for team logos of a given sport.
 * @param sport - Sport code (case-insensitive)
 * @returns File extension without dot, e.g. 'svg' or 'png'
 */
export function getFileExtForSport(sport: string): string {
  return SPORT_FILE_EXTENSIONS[sport.toLowerCase()] || DEFAULT_FILE_EXTENSION;
}
